import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { apiRoutes } from 'src/app/constants/apiRoutes';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ApiCallMethodsService } from 'src/app/shared/services/api-call-methods.service';
import { SharedService } from 'src/app/shared/services/shared-service/shared.service';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  customerList: any = null;
  orgId: any = null;
  SharingData = new Subject();
  userDetails: any = null;
  companyData: any = null;
  orgName: any = null;
  companyProfileDetails: any = null;
  totalDashboard: any = null;
  recentInvoice: any;
  csvStartDate: any = '';
  csvEndDate: any = '';
payload = {
  date_range: {
    start: null,
    end: null
  }
};


  constructor(private apiCallMethodsService: ApiCallMethodsService, private authService: AuthService,
    private sharedService: SharedService,

  ) {
    this.orgId = this.authService.getId();
    this.userDetails = this.authService.getSessionDetail();

    this.sharedService.dateFilterUpdated.subscribe((data: any) => {
      this.csvStartDate = data?.start;
      this.csvEndDate = data?.end;
console.log(this.csvStartDate);

      if (data?.from == 'dashboard-list' && (data?.start || data?.remove == true)) {
console.log(this.csvStartDate);

        this.payload.date_range.start = this.csvStartDate;
        this.payload.date_range.end = this.csvEndDate;
console.log(this.payload.date_range.start);

        this.overDueTopFive(this.payload);
      }

    });

  };

  

  overDueTopFive(payLoad: any = null) {
    let apiUrl = apiRoutes.overDueDashboard + '/' + this.orgId + '?start_date=' + this.payload?.date_range?.start + '&end_date=' + this.payload?.date_range?.end + '&contact_id=' + (payLoad?.customer_id || '');

    this.apiCallMethodsService.get(apiUrl).subscribe((response: any) => {
      this.totalDashboard = response;

      let dashboardData;
      
      dashboardData = {
        dashboard: this.totalDashboard,
      }

      this.SharingData.next(dashboardData);

    },
      (error: any) => {

        let dashboardData = {
          dashboard: [],
        };

        this.SharingData.next(dashboardData);

      })

  }

  getCompanyDetails() {
    let url = apiRoutes.selectedOrgProfile + '/' + this.orgId;
    this.apiCallMethodsService.get(url).subscribe((response: any) => {

      let companyData;
      this.companyProfileDetails = response;

      companyData = {
        company: this.companyProfileDetails,
      }

      this.SharingData.next(companyData);

    },
      (error: any) => {

        let companyData = {
          company: [],
        };

        this.SharingData.next(companyData);

      });

  }


  getCompanyName() {
    let orgProfileUrl = apiRoutes.orgProfile + '/' + this.userDetails?.user?.user_id;
    this.apiCallMethodsService.get(orgProfileUrl).subscribe((response: any) => {
      let orgData;
      this.companyData = response;

      orgData = {
        orgList: this.companyData,
      }

      this.SharingData.next(orgData);

    },
      (error: any) => {

        let orgData = {
          orgList: [],
        };

        this.SharingData.next(orgData);

      });

  }

  newCustomerList() {
    let url = apiRoutes.customerInvoice + '/' + this.orgId;
    this.apiCallMethodsService.get(url).subscribe((response: any) => {
      this.customerList = response?.customer;
      // this.filterCustomer = this.customerList;
      let cusData;

      this.customerList = response;

      cusData = {
        cusList: this.customerList,
      }


      this.SharingData.next(cusData);

    },
      (error: any) => {

        let cusData = {
          cusList: [],
        };

        this.SharingData.next(cusData);

      });


  };

  downloadPdf(invoice: any, pdfLink: any) {
    let fileUrl = `${apiRoutes.generatePdf}/${invoice?.iqp_id}`;
    const data = {
      path: pdfLink,
      iqp_invoice_number: invoice?.iqp_invoice_number,
    };
    this.apiCallMethodsService.postPdf(fileUrl, data).subscribe((response: any) => {
      let blob = new Blob([response.body], { type: 'application/pdf' });
      let pdfUrl = window.URL.createObjectURL(blob);
      let fileName = response.headers;
      var PDF_link = document.createElement('a');
      PDF_link.href = pdfUrl;
      window.open(pdfUrl, '_blank');

      PDF_link.download = invoice?.iqp_invoice_number;
      PDF_link.click();
    });
  };




}
